import _findIndex from 'lodash/findIndex';
import KEYS from 'common/KeyCodes';
import BREAKPOINTS from './styles/breakpoints';

const CONSTANTS = {
  LIST_ITEM_TABABLE_ITEM: 'data-ccfk-launchpad-tile',
  ...KEYS
};

const {
  LIST_ITEM_TABABLE_ITEM, ARROW_UP, ARROW_DOWN, ARROW_LEFT, ARROW_RIGHT, HOME, END
} = CONSTANTS;

/** keyboard navigation on Lists or whatever elements use LIST_ITEM_TABABLE_ITEM and LIST_WRAPPER to identify keyboard items. */
const handleKeyDown = (ref, rtl = false) => (event) => {
  if (!ref) {
    return;
  }
  const { key } = event;
  const elements = ref.current.querySelectorAll(`[${LIST_ITEM_TABABLE_ITEM}]`);
  const first = elements[0];
  const last = elements[elements.length - 1];
  const current = document.activeElement;
  const shouldNotFocus = element => !element.hasAttribute(LIST_ITEM_TABABLE_ITEM) || element.disabled;

  const currentIndex = _findIndex(elements, elem => (elem as HTMLElement).contains(current));
  const numberOfElements = elements.length;

  const getRowCount = () => {
    // determines how many tiles would be showing, so we can reason how to navigate down vertically.
    const bp = Object.keys(BREAKPOINTS).find(b =>
      window.matchMedia(`(min-width: ${(BREAKPOINTS[b].MIN as number).toString()}px)${BREAKPOINTS[b].MAX ? ` and (max-width: ${(BREAKPOINTS[b].MAX as number).toString()}px` : ''}`).matches);
    return BREAKPOINTS[bp] && BREAKPOINTS[bp].TILES - 1;
  };

  const prevItem = itemIndex => (itemIndex > 0 ? elements[itemIndex - 1] : last);
  const nextItem = (itemIndex: number) => (itemIndex + 1 < numberOfElements ? elements[itemIndex + 1] : first);

  const prevItemVertical = (itemIndex) => {
    const rowCount = getRowCount();
    const nextIndex = itemIndex - rowCount;
    return itemIndex > 0 && elements[nextIndex - 1];
  };
  const nextItemVertical = (itemIndex: number) => {
    const rowCount = getRowCount();
    const nextIndex = rowCount + itemIndex + 1;
    return nextIndex < numberOfElements && elements[nextIndex];
  };

  const shiftFocus = (currentItemIndex: {}, traverse: (any) => any = () => {}) => {
    let loopedOnce = false;
    let nextFocus = traverse(currentItemIndex);

    while (nextFocus) {
      if (nextFocus === first) {
        if (loopedOnce) return false;
        loopedOnce = true;
      }
      if (shouldNotFocus(nextFocus)) {
        nextFocus = traverse(nextFocus);
      } else {
        nextFocus.focus();
        return true;
      }
    }
    return false;
  };

  switch (key) {
    case ARROW_UP:
      event.preventDefault();
      shiftFocus(currentIndex, prevItemVertical);
      break;
    case ARROW_LEFT:
      event.preventDefault();
      // eslint-disable-next-line no-unused-expressions
      rtl ? shiftFocus(currentIndex, nextItem) : shiftFocus(currentIndex, prevItem);
      break;
    case ARROW_DOWN:
      event.preventDefault();
      shiftFocus(currentIndex, nextItemVertical);
      break;
    case ARROW_RIGHT:
      event.preventDefault();
      // eslint-disable-next-line no-unused-expressions
      rtl ? shiftFocus(currentIndex, prevItem) : shiftFocus(currentIndex, nextItem);
      break;
    case HOME:
      event.preventDefault();
      first && first.focus();
      break;
    case END:
      event.preventDefault();
      last && last.focus();
      break;
    default:
      break;
  }
};

export { handleKeyDown, CONSTANTS };
